// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"195":"7b759e0d","270":"b3806203","422":"da84c57f","439":"3f817abe","483":"8a237e1c","491":"cf3e9fd9","529":"93a5fd61","787":"7daeee58","954":"e5e9d0f8","960":"75fc825e","983":"6bd645c1"}[chunkId] + ".chunk.js";
};